export default "__VITE_ASSET__CX7_DDVv__"